/**
 * PHASE 2: Enhanced error logging with correlation IDs and anonymized context
 */

export interface ErrorLogContext {
  component?: string;
  action?: string;
  metadata?: Record<string, unknown>;
}

// Enhanced logging with correlation IDs and anonymized PII
export const logError = (message: string, error?: Error, context?: ErrorLogContext) => {
  const componentName = context?.component || 'Unknown';
  const errorId = context?.metadata?.errorId || crypto.randomUUID();
  
  // Anonymize PII in metadata (userId -> u_XXX, email -> e_XXX)
  const sanitizedMetadata = context?.metadata ? 
    Object.entries(context.metadata).reduce((acc, [key, value]) => {
      if (key === 'userId' && typeof value === 'string') {
        acc[key] = `u_${value.substring(0, 8)}`;
      } else if (key === 'email' && typeof value === 'string') {
        acc[key] = `e_${value.split('@')[0].substring(0, 3)}@***`;
      } else if (key === 'errorId') {
        acc[key] = value; // Keep error ID as-is
      } else {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, unknown>) : {};
  
  console.error(`[${componentName}] [${errorId}] ${message}`, error || '');
  if (Object.keys(sanitizedMetadata).length > 0) {
    console.error('Context:', sanitizedMetadata);
  }
};

export const logWarning = (message: string, context?: ErrorLogContext) => {
  const componentName = context?.component || 'Unknown';
  console.warn(`[${componentName}] ${message}`);
};

export const logInfo = (message: string, context?: ErrorLogContext) => {
  const componentName = context?.component || 'Unknown';
  console.info(`[${componentName}] ${message}`);
};
